import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Map } from "immutable";
import api from "APP_ROOT/api";
import { shortDate } from "LIB/formatters/date";
import { dollars } from "LIB/formatters/currency";
import {
  ACCOUNTING,
  QUALITY_CONTROL_MANAGER,
  REPAIR
} from "MODULES/users/constants";
import SendRepairOrderDocuments from "MODULES/RepairOrders/components/Detail/SendRepairOrderDocuments/SendRepairOrderDocuments";
import { CANCELLATION_REASONS } from "MODULES/Orders/shared/constants";
import RecordPager from "MODULES/shared/components/RecordPager/RecordPager";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import ExternalLink from "MODULES/shared/components/ExternalLink/ExternalLink";
import ConfirmAction from "MODULES/shared/components/ConfirmAction/ConfirmAction";
import { cancel, update } from "MODULES/RepairOrders/actions";
import ActionDropDown from "MODULES/shared/components/ActionDropDown/ActionDropDown";
import SendEmail from "MODULES/shared/components/SendEmail";
import Warnings from "MODULES/RepairOrders/components/Detail/Warnings";
import ConfirmApproval from "MODULES/RepairOrders/components/Detail/ConfirmApproval/ConfirmApproval";
import {
  Authorized,
  StatusTag,
  ClipboardCopy
} from "MODULES/shared/components";
import RemoveFromQCHold from "MODULES/shared/components/RemoveFromQCHold";
import {
  API_BASE,
  CANCELLED,
  CODE,
  CREATED_AT,
  LINE_ITEMS,
  SHIPPED
} from "APP_ROOT/constants";
import { APPROVED, TEARDOWN } from "MODULES/RepairOrders/constants";
import { QC_HOLD } from "MODULES/inventories/constants";
import ImportExpectedComponents from "APP_ROOT/modules/RepairOrders/components/Detail/ImportExpectedComponents/ImportExpectdComponents";
import UpdateEvaluationStatus from "MODULES/RepairOrders/components/Detail/UpdateEvaluationStatus/UpdateEvaluationStatus";
import EditEvaluationStatusModal from "MODULES/RepairOrders/components/Detail/UpdateEvaluationStatus/UpdateEvaluationStatusModal";
import Sync from "MODULES/RepairOrders/components/Detail/Sync/Sync";
import ToggleQuickbooksSync from "MODULES/RepairOrders/components/Detail/ToggleQuickbooksSync/ToggleQuickbooksSync";
import EditInvoiceDetails from "./EditInvoiceDetails";

export class Header extends React.Component {
  state = {
    cancellationReason: CANCELLATION_REASONS[0].value,
    cancelOrderModalOpen: false,
    importModalOpen: false,
    sendOrderModalOpen: false,
    toggleApprovalModal: false
  };

  onConfirmToRemoveFormQCHoldClick = () => {
    const { updateRepairOrder } = this.props;

    updateRepairOrder({ qc_hold: false });
  };

  handleSelectChange = e => {
    this.setState({ cancellationReason: e.target.value });
  };

  closeCancelOrderModal = () => this.setState({ cancelOrderModalOpen: false });

  openCancelOrderModal = () => this.setState({ cancelOrderModalOpen: true });

  openimportModal = () => this.setState({ importModalOpen: true });

  openApprovalModal = () => this.setState({ toggleApprovalModal: true });

  toggle = modalType => () =>
    this.setState({ [modalType]: !this.state[modalType] });

  render() {
    const { repairOrder, cancelRepairOrder, id } = this.props;
    const {
      cancelOrderModalOpen,
      importModalOpen,
      toggleApprovalModal
    } = this.state;
    const cancelled = repairOrder.get(CANCELLED);
    const forSecondOpinion = repairOrder
      .get(LINE_ITEMS)
      .some(i => i.get("for_second_opinion"));
    const cancellable = repairOrder
      .get(LINE_ITEMS)
      .every(i => i.get("cancellable"));

    const lineItemsShipped = repairOrder
      .get(LINE_ITEMS)
      .every(i => i.get(SHIPPED));

    const teardown = repairOrder
      .toJS()
      .line_items.filter(l => l.action_requested === TEARDOWN)[0];

    const hasActiveRma = repairOrder.get("active_customer_rma");

    return (
      <div className="page-header page-header-bar">
        <h1>
          <div className="btn-group pull-right" style={{ marginLeft: 20 }}>
            <ActionDropDown
              menuClass="dropdown-menu-right"
              style={{ cursor: "pointer" }}
            >
              <Authorized roles={[REPAIR]} subroles={[QUALITY_CONTROL_MANAGER]}>
                <RemoveFromQCHold
                  order={repairOrder}
                  orderType="RO"
                  onConfirm={this.onConfirmToRemoveFormQCHoldClick}
                />
              </Authorized>
              {!cancelled && (
                <React.Fragment>
                  <Authorized authorizedIf={() => repairOrder.get(APPROVED)}>
                    <li key="download-ro">
                      <ExternalLink
                        url={`${API_BASE}/repair_orders/${id}/download`}
                      >
                        <i className="fa fa-fw fa-file-text-o" />
                        &nbsp;Download RO
                      </ExternalLink>
                    </li>
                    <SendRepairOrderDocuments repairOrder={repairOrder} />
                  </Authorized>
                  <Authorized roles={[ACCOUNTING]}>
                    <EditInvoiceDetails repairOrder={repairOrder} />
                  </Authorized>
                  <ConfirmApproval
                    repairOrder={repairOrder}
                    onConfirm={this.props.approveRepairOrder}
                  />
                  {lineItemsShipped && (
                    <React.Fragment>
                      <SendEmail
                        record={repairOrder}
                        label={"request for evaluation"}
                        url={api.repairOrders}
                        type={"quote"}
                      />
                      <SendEmail
                        record={repairOrder}
                        label="request for shipping status"
                        url={api.repairOrders}
                        type={"status"}
                      />
                    </React.Fragment>
                  )}

                  <li className="divider" key="ro-divider" />
                </React.Fragment>
              )}
              {!!teardown && [
                <DropDownItem onClick={this.openimportModal}>
                  <span>
                    <i className="fa fa-fw fa-download" />{" "}
                    <span>Import Expected Sub-Components</span>
                  </span>
                </DropDownItem>,
                <UpdateEvaluationStatus
                  toggleApprovalModal={this.openApprovalModal}
                />,
                <li className="divider" key="ro-divider" />
              ]}
              {(cancelled || cancellable) && (
                <DropDownItem onClick={this.openCancelOrderModal}>
                  <span className="text-danger">
                    <i className="fa fa-fw fa-ban" />{" "}
                    {cancelled ? (
                      <span>Reopen Order</span>
                    ) : (
                      <span>Cancel Order</span>
                    )}
                  </span>
                </DropDownItem>
              )}
              <Authorized roles={[ACCOUNTING]}>
                <ToggleQuickbooksSync repairOrder={repairOrder} />
                <Sync repairOrder={repairOrder} />
              </Authorized>
            </ActionDropDown>
          </div>
          <RecordPager baseUrl="/repair-orders" record={repairOrder} />
          &nbsp;
          <span className="header-content">{repairOrder.get(CODE)}</span>
          &nbsp;
          <ClipboardCopy name={repairOrder.get(CODE)} type="RO" />
          <span className="small text-muted">
            Created {shortDate(repairOrder.get(CREATED_AT))}
          </span>
          <span className="pull-right">
            {repairOrder.get(QC_HOLD) && (
              <StatusTag title="QC Hold" icon="pause" display="danger" />
            )}{" "}
            {forSecondOpinion && (
              <Fragment>
                <StatusTag
                  title="Second Opinion"
                  icon="retweet"
                  display="warning"
                />{" "}
              </Fragment>
            )}
            {hasActiveRma && (
              <span className="label label-danger">
                <i className="fa fa-cog" />
                &nbsp;&nbsp;Cust. RMA
              </span>
            )}
            <span className="small text-muted">
              {repairOrder.get(LINE_ITEMS, []).size} Item(s)
            </span>
            &nbsp;&nbsp;Total: {dollars(repairOrder.get("total"))}
          </span>
          <Warnings repairOrder={repairOrder} />
        </h1>

        <ImportExpectedComponents
          close={this.toggle("importModalOpen")}
          open={importModalOpen}
        />
        <EditEvaluationStatusModal
          close={this.toggle("toggleApprovalModal")}
          repairOrder={repairOrder}
          visible={toggleApprovalModal}
        />
        <ConfirmAction
          onConfirm={() => cancelRepairOrder(this.state.cancellationReason)}
          close={this.closeCancelOrderModal}
          open={cancelOrderModalOpen}
          btnClass={cancelled ? "btn-primary" : "btn-danger"}
          btnText={cancelled ? "Reopen Order" : "Yes, Cancel Order"}
          cancelText={cancelled ? "Cancel" : "Do Not Cancel Order"}
          icon={
            cancelled ? (
              <i className="fa fa-fw fa-refresh" />
            ) : (
              <i className="fa fa-fw fa-ban" />
            )
          }
        >
          <strong>Heads up!</strong>
          &nbsp;
          {cancelled
            ? "Are you sure you want to reopen this?"
            : "Cancelling an RO will cancel all line items associated with it."}
          {!cancelled && (
            <div>
              <label className="control-label" htmlFor="cancellation_reason">
                Cancellation Reason
              </label>
              <select
                className="form-control"
                name="cancellation_reason"
                onChange={e => this.handleSelectChange(e)}
              >
                {CANCELLATION_REASONS.map(reason => (
                  <option key={reason.value} value={reason.value}>
                    {reason.text}
                  </option>
                ))}
              </select>
            </div>
          )}
        </ConfirmAction>
      </div>
    );
  }
}

export default connect(
  state => ({
    id: state.repairOrderDetail.getIn(["repairOrder", "id"])
  }),
  dispatch => ({
    cancelRepairOrder: data => dispatch(cancel(data)),
    updateRepairOrder: data => dispatch(update(data)),
    approveRepairOrder: () => dispatch(update({ approved: true }))
  })
)(Header);

Header.propTypes = {
  approveRepairOrder: PropTypes.func.isRequired,
  repairOrder: PropTypes.instanceOf(Map),
  id: PropTypes.number.isRequired,
  cancelRepairOrder: PropTypes.func.isRequired,
  updateRepairOrder: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/Header.jsx